import { render, staticRenderFns } from "./updateSchemaTransactionTypeCharges.vue?vue&type=template&id=4882be09"
import script from "./updateSchemaTransactionTypeCharges.vue?vue&type=script&lang=js"
export * from "./updateSchemaTransactionTypeCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports